/* eslint-disable no-unused-vars */
const Autodesk = window.Autodesk;
import store from '@/store';
import { removeFromScene, pointerToRaycaster, createTextGl, addToScene } from '../utils/forgeUtils'
import { drawBoxLines } from '../utils/threejsUtils'
import { drawPoint } from '../utils/threejsUtils'
import { saveLevels, editType } from '../utils/mongoUtils'
import { MappingViewersInfo } from './../scripts/js/forgeModels';
const THREE = window.THREE;

export default class Mapping2d_3dExtension extends Autodesk.Viewing.Extension {
    constructor(loadedViewer, options) {
        super(loadedViewer, options);
        this.viewer = loadedViewer;
        this.webGLDOM = this.viewer.canvas.parentElement.parentElement.parentElement;
        
        this.sceneName = 'potree-scene';
        this.pointsColor = 0x000000;

        this.draggingLevelInfo = null;
        this.draggingPoint = null;
        this.pointTypes = {
            TopLeft: 'topLeft',
            TopRight: 'topRight',
            BottomRight: 'bottomRight',
            BottomLeft: 'bottomLeft',
        }
        //every row will be like {level:level, planeMesh:mesh, minPt:pt, maxPt:pt, points:[{point:point, mesh:mesh, type:type},,,]}
        this.mappedLevelsInfos = []
        this.boxes = [];

        this.showControls = !store.state.mainApp;
        if(this.showControls){
            let _this = this;
            this.webGLDOM.addEventListener("click", (event) => {
                _this.onMouseUp(event);
            });
            this.viewer.canvas.addEventListener("mousedown", (event) => {
                _this.onMouseDown(event);
            });
            this.webGLDOM.addEventListener("mousemove", (event) => {
                _this.onMouseMove(event);
            }, false);
        }
    }

    load() {
        this.updateShownLevels()
        return true;
    }
    unload() {
        return true;
    }
    onToolbarCreated() {

    }
    updateShownLevels() {
        //remove old meshes
        removeFromScene(this.boxes, this.viewer, this.sceneName);
        this.boxes = []
        for (let i = 0; i < this.mappedLevelsInfos.length; i++) {
            removeFromScene(this.mappedLevelsInfos[i].planeMesh, this.viewer, this.sceneName);
            if (this.mappedLevelsInfos[i].points) {
                this.mappedLevelsInfos[i].points.forEach(o => removeFromScene(o.mesh, this.viewer, this.sceneName))
            }
        }

        //build list again
        this.mappedLevelsInfos = []
        for (let i = 0; i < store.state.levels.length; i++) {
            let level = store.state.levels[i]
            if (!level.isShowingIn3D || !level.planImageUrl||!level.hasAllMappingInfo())
                continue;

            let levelBox = level.getViewCropBox();
            if(this.showControls){
                //draw level box mesh
                let levelBoxLines = drawBoxLines(levelBox,0x0000ff,this.viewer,this.sceneName, .5)
                levelBoxLines.material.depthTest = true
                levelBoxLines.material.depthWrite = true
                this.boxes.push(levelBoxLines)
            }
            
            let planeZ = levelBox.min.z;
            let minPt = store.state.forgeService.worldToView3d(level.mappingViewersPointsInfo.min)
            let maxPt = store.state.forgeService.worldToView3d(level.mappingViewersPointsInfo.max)
            minPt.setZ(planeZ)
            maxPt.setZ(planeZ)

            //draw plane
            const texture = THREE.ImageUtils.loadTexture(level.planImageUrl);
            const material = new THREE.MeshBasicMaterial({ map: texture });
            material.side = THREE.DoubleSide;
            const geometry = new THREE.PlaneGeometry(maxPt.x - minPt.x, maxPt.y - minPt.y);
            let planeMesh = new THREE.Mesh(geometry, material);
            let meshCenter = new THREE.Box3(minPt, maxPt).getCenter()
            planeMesh.position.set(meshCenter.x, meshCenter.y, planeZ);
            addToScene(planeMesh, this.viewer, this.sceneName)

            let pointsControls = []
            if (this.showControls) {
                let topLeftPt = new THREE.Vector3(minPt.x, maxPt.y, planeZ)
                let bottomRightPt = new THREE.Vector3(maxPt.x, minPt.y, planeZ)
                let size = store.state.forgeService.worldToView3dLength(1)
                pointsControls = [
                    { point: topLeftPt, type: this.pointTypes.TopLeft, mesh: drawPoint(topLeftPt, this.pointsColor, this.viewer, this.sceneName, size) },
                    { point: maxPt, type: this.pointTypes.TopRight, mesh: drawPoint(maxPt, this.pointsColor, this.viewer, this.sceneName, size) },
                    { point: bottomRightPt, type: this.pointTypes.BottomRight, mesh: drawPoint(bottomRightPt, this.pointsColor, this.viewer, this.sceneName, size) },
                    { point: minPt, type: this.pointTypes.BottomLeft, mesh: drawPoint(minPt, this.pointsColor, this.viewer, this.sceneName, size) },
                ]
            }
            let levelInfo = {
                level: level,
                planeMesh: planeMesh,
                points: pointsControls
            }
            this.mappedLevelsInfos.push(levelInfo)
        }
        this.viewer.impl.invalidate(true,true,true);
    }
    getIntersectionPointUnderMouse(raycaster){
        let drawnLevels = this.mappedLevelsInfos.filter(o => !!o.planeMesh)
        let intersectedLevel = drawnLevels.find(o => o.points.some(e => raycaster.intersectObject(e.mesh).length>0))
        if (!intersectedLevel)
            return null;
        let intersection = intersectedLevel.points.find(o => raycaster.intersectObject(o.mesh).length>0)
        return {point : intersection , level: intersectedLevel}
    }
    uploadDrawnLevelPlane(levelInfo,points){
        if(!levelInfo.level.mappingViewersPointsInfo)
            levelInfo.level.mappingViewersPointsInfo = new MappingViewersInfo();
        let box = new THREE.Box3().setFromPoints(points)
        levelInfo.level.mappingViewersPointsInfo.min = store.state.forgeService.view3dToWorld(box.min)
        levelInfo.level.mappingViewersPointsInfo.max = store.state.forgeService.view3dToWorld(box.max)
        let topLeftPtNew = new THREE.Vector3(box.min.x, box.max.y, box.min.z)
        let bottomRightPtNew = new THREE.Vector3(box.max.x, box.min.y, box.min.z)

        let topLeftPt = levelInfo.points.find(o=>o.type == this.pointTypes.TopLeft)
        let topRightPt = levelInfo.points.find(o=>o.type == this.pointTypes.TopRight)
        let bottomRightPt = levelInfo.points.find(o=>o.type == this.pointTypes.BottomRight)
        let bottomLeftPt = levelInfo.points.find(o=>o.type == this.pointTypes.BottomLeft)
        topLeftPt.point = topLeftPtNew
        topLeftPt.mesh.position.set(topLeftPtNew.x, topLeftPtNew.y, topLeftPtNew.z)
        bottomRightPt.point = bottomRightPtNew
        bottomRightPt.mesh.position.set(bottomRightPtNew.x, bottomRightPtNew.y, bottomRightPtNew.z)
        bottomLeftPt.point = box.min
        bottomLeftPt.mesh.position.set(box.min.x, box.min.y, box.min.z)
        topRightPt.point = box.max
        topRightPt.mesh.position.set(box.max.x, box.max.y, box.max.z)

        let meshCenter = box.getCenter()
        const geometry = new THREE.PlaneGeometry(box.max.x - box.min.x, box.max.y - box.min.y);
        levelInfo.planeMesh.geometry.dispose()
        levelInfo.planeMesh.geometry = geometry;
        let levelBox = levelInfo.level.getViewCropBox();
        levelInfo.planeMesh.position.set(meshCenter.x, meshCenter.y, levelBox.min.z);
        this.viewer.impl.invalidate(true, true, true);
    }
    onMouseMove(mouse) {
        if (!this.viewer.impl||this.mappedLevelsInfos.length==0)
            return;

        if (!this.dragged)
            this.dragged = true;
        let raycaster = pointerToRaycaster(this.viewer, mouse);
        this.mappedLevelsInfos.forEach(o => {
            if (o.points) {
                o.points.forEach(o => {
                    o.mesh.material.color = new THREE.Color(0x000000)
                    o.mesh.material.needsUpdate = true
                });
            }
        })

        if (this.draggingPoint) {
            let plane = new THREE.Plane(new THREE.Vector3(0, 0, 1), -this.draggingPoint.point.z);

            let intersectionWithPlane = raycaster.ray.intersectPlane(plane);
            if(!intersectionWithPlane)
                return;
            intersectionWithPlane = new THREE.Vector3( intersectionWithPlane.x, intersectionWithPlane.y,this.draggingPoint.point.z)
            
            //setting location of current point
            this.draggingPoint.mesh.position.set(intersectionWithPlane.x,intersectionWithPlane.y,intersectionWithPlane.z)
            let topLeftPt = this.draggingLevelInfo.points.find(o=>o.type == this.pointTypes.TopLeft)
            let topRightPt = this.draggingLevelInfo.points.find(o=>o.type == this.pointTypes.TopRight)
            let bottomRightPt = this.draggingLevelInfo.points.find(o=>o.type == this.pointTypes.BottomRight)
            let bottomLeftPt = this.draggingLevelInfo.points.find(o=>o.type == this.pointTypes.BottomLeft)
            let twoOppsPoints = [intersectionWithPlane]
            let height= topRightPt.point.y - bottomLeftPt.point.y
            let width = topRightPt.point.x - bottomLeftPt.point.x
            switch (this.draggingPoint.type) {
                case 'topLeft':
                    twoOppsPoints.push(bottomRightPt.point)
                    break;
                case 'topRight':
                    twoOppsPoints.push(bottomLeftPt.point)
                    break;
                case 'bottomRight':
                    twoOppsPoints.push(topLeftPt.point)
                    break;
                case 'bottomLeft':
                    twoOppsPoints.push(topRightPt.point)
                    break;
            }
            //force the height to be related to the width to keep the width/height ratio
            let newHeight = height *  Math.abs(intersectionWithPlane.x-twoOppsPoints[1].x) /width
            intersectionWithPlane.y = this.draggingPoint.type.includes('top')? twoOppsPoints[1].y + newHeight:twoOppsPoints[1].y - newHeight

            this.uploadDrawnLevelPlane(this.draggingLevelInfo,twoOppsPoints)
        } else {
            let raycaster = pointerToRaycaster(this.viewer, mouse);
            let intersectedPoint = this.getIntersectionPointUnderMouse(raycaster)
            if (intersectedPoint) {
                intersectedPoint.point.mesh.material.color = new THREE.Color(0x0000ff)
                intersectedPoint.point.mesh.material.needsUpdate = true
            }
            this.viewer.impl.invalidate(false, false, true);
        }
    }
    onMouseDown(mouse) {
        if (this.mappedLevelsInfos.length == 0)
            return;
        if (mouse.which != 1)
            return;
        let raycaster = pointerToRaycaster(this.viewer, mouse);
        let intersectedPoint = this.getIntersectionPointUnderMouse(raycaster)
        if (intersectedPoint){
            this.draggingLevelInfo = intersectedPoint.level
            this.draggingPoint = intersectedPoint.point

            this.viewer.navigation.setIsLocked(true);
        }else{
            this.dragged = false;
        }
    }
    onMouseUp(mouse) {
        if (mouse.which != 1)
            return;
        if (this.mappedLevelsInfos.length == 0) {
            this.viewer?.navigation?.setIsLocked(false);
            return;
        }

        if (this.draggingLevelInfo) {
            saveLevels(this.draggingLevelInfo.level, editType.EDIT_LEVEL);
            this.draggingLevelInfo = null;
            this.draggingPoint = null;
            this.viewer.impl.invalidate(true, true, true);
        }

        this.dragged = false;
        this.viewer.navigation.setIsLocked(false);
    }

}
Autodesk.Viewing.theExtensionManager.registerExtension('Mapping2d_3dExtension', Mapping2d_3dExtension);
